<template>
  <transition name="fade" mode="out-in">
    <div v-if="isOpen" class="modal-wrapper verify-phone">
      <div class="modal-overlay" @click="emits('close')" />
      <div class="modal-box">
        <div class="modal-body">
          <PhoneVerification
            title="Finalisez votre inscription"
            text="Pour terminer votre inscription et accéder à votre évaluation en ligne, veuillez indiquer votre numéro de téléphone."
            :displayIcon="true"
            @verified="(data) => onPhoneVerified(data)"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useCandidateStore } from "@/stores/candidate.js";
import { getError } from "@/composables/error.js";
import { setToken } from "@/composables/token.js";
import { useToast } from "vue-toastification";
import PhoneVerification from "@/components/PhoneVerification.vue";

const candidateStore = useCandidateStore();

const toast = useToast();

const emits = defineEmits(["close", "verified"]);

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

async function onPhoneVerified({ phone, verification_id }) {
  const resp = await candidateStore.updatePhone(phone, verification_id);

  if (resp.token) {
    setToken(resp.token, "auth_token_game", candidateStore.auth_token_game);
    Object.assign(candidateStore.candidate, resp.candidate);
    emits("verified");
  } else {
    toast.error(getError(resp.key));
  }
}
</script>
